module.exports = __webpack_public_path__ + "img/message.0c982f5d.png";